import * as TYPES from '../../store/types'

const state = {
  status: null,
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.WIZARD_SET_DATA](st, obj) {
    if (obj.status !== undefined) st.status = obj.status
  },
}

const actions = {
  wizardSetData({ commit }, obj) {
    commit(TYPES.WIZARD_SET_DATA, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
